/**
 * TipPicker — ÚNICO selector de propina de Ziyup (Cobrar y pago desde la app del cliente), founder 21-oct-2026.
 * 20 % · 25 % · 30 % · «Otro monto» · «Sin propina». El % se calcula sobre `base` = servicio − descuentos
 * (sin cargos de Stripe ni impuestos) y se muestra en dólares junto a cada opción («20% · $12»).
 * value: { mode: 0 | 20 | 25 | 30 | 'custom', custom: string }  →  tipAmount(value, base) da el monto final.
 */
import { tr } from '@/contexts/LanguageContext';
import { fmtMoney } from '@/utils/money';

export const TIP_PERCENTS = [20, 25, 30];
export const DEFAULT_TIP = { mode: 0, custom: '' };

export const tipAmount = (value, base) => {
  if (!value || value.mode === 0) return 0;
  const raw = value.mode === 'custom' ? Number(value.custom || 0) : Number(base || 0) * (Number(value.mode) / 100);
  return Math.max(Math.round(raw * 100) / 100, 0);
};

export const TipPicker = ({ value = DEFAULT_TIP, onChange, base = 0, maxCustom = 500, testPrefix = 'tip', label = tr("Propina para tu barbero") }) => {
  const chip = (active) => `h-9 px-3 rounded-full border text-xs font-semibold transition-colors tabular-nums ${
    active ? 'bg-primary text-primary-foreground border-primary' : 'bg-card border-border text-foreground hover:border-primary/50'}`;
  return (
    <div data-testid={`${testPrefix}-picker`}>
      {label && <p className="text-[11px] text-muted-foreground mb-1.5">{label}</p>}
      <div className="flex flex-wrap gap-1.5">
        {TIP_PERCENTS.map((p) => (
          <button key={p} type="button" onClick={() => onChange({ mode: p, custom: '' })} className={chip(value.mode === p)}
            data-testid={`${testPrefix}-${p}`}>
            {p}% · {fmtMoney(tipAmount({ mode: p }, base))}
          </button>
        ))}
        <button type="button" onClick={() => onChange({ mode: 'custom', custom: value.custom || '' })} className={chip(value.mode === 'custom')}
          data-testid={`${testPrefix}-custom`}>{tr("Otro monto")}</button>
        <button type="button" onClick={() => onChange({ mode: 0, custom: '' })} className={chip(value.mode === 0)}
          data-testid={`${testPrefix}-0`}>{tr("Sin propina")}</button>
      </div>
      {value.mode === 'custom' && (
        <div className="mt-2 flex items-center gap-2">
          <span className="text-sm text-muted-foreground">$</span>
          <input type="number" inputMode="decimal" min="0" max={maxCustom} step="1" value={value.custom} autoFocus placeholder="0"
            onChange={(e) => onChange({ mode: 'custom', custom: e.target.value === '' ? '' : String(Math.max(0, Math.min(maxCustom, Number(e.target.value)))) })}
            className="h-9 w-28 rounded-lg bg-card border border-border px-3 text-sm text-foreground tabular-nums focus:outline-none focus:border-primary"
            data-testid={`${testPrefix}-custom-input`} />
        </div>
      )}
    </div>
  );
};
